// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pWDO","buttons":"styles_buttons__2z1AW"};